import config from "./Secrets";

export const API_BASE_URL = `${config.API_BASE_PATH}/api/v1`;

export const USERS = `${API_BASE_URL}/users`;
export const RECIPES = `${API_BASE_URL}/recipes`;
export const SITES = `${API_BASE_URL}/sites`;
export const NOTES = `${API_BASE_URL}/notes`;
